<script setup>
import { useI18n } from 'vue-i18n';
import axios from 'axios';
import { onMounted, ref } from 'vue';
const { locale } = useI18n();

const counters = ref([]);

async function getCounters() {
    try {
        const res = await axios.get('/counters-data');
        counters.value = res.data || [];
    } catch (error) {
        console.error('Error fetching :', error);
    }
}

onMounted(() => {
    getCounters();
})
</script>
<template>
    <div class="lg:w-1/2 md:w-1/2 lg:mt-12 wow animate__animated animate__fadeInRight">
        <div class="flex flex-wrap">
            <div class="p-2 lg:w-1/2 w-full" v-for="counter in counters" :key="counter.id">
                <div class="flex bg-primary/5 px-4 py-10 xl:h-40 h-32 shadow shadow-gray-300 rounded-md">
                    <p v-html="counter?.icon"></p>
                    <div class="pl-6">
                        <vue3-autocounter class="title-font font-medium text-xl text-gray-800 mb-2" ref='counter'
                            :startAmount='10000' :endAmount='Number(counter?.count)' :duration='3'
                            :suffix="counter?.suffix" separator='' decimalSeparator='.' :decimals='0' :autoinit='true' />
                        <p class="font-medium xl:text-lg text-base text-gray-800">{{ locale === 'BN' ? counter?.bn_title : counter?.title }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped></style>
